import React from 'react';

import { SVGProps } from './type';

function Icon(props: SVGProps) {
  const { size = 24, color = '#000' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 256 256"
    >
      <path fill="none" d="M0 0H256V256H0z" />
      <circle
        cx="128"
        cy="140"
        r="40"
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="16"
      />
      <path
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="16"
        d="M196 116a59.8 59.8 0 0148 24M12 140a59.8 59.8 0 0148-24M70.4 216a64.1 64.1 0 01115.2 0M60 116a32 32 0 1131.4-38M164.6 78a32 32 0 1131.4 38"
      />
    </svg>
  );
}

export default Icon;
